export default __webpack_public_path__ + "static/media/CustomerDetail.759a2ac2.png";